import { createApiClient } from "Network/ApiClient";

export const PatientDrugsManagementAxiosInstance =
  createApiClient("Drugspatient/");
